import Ajax from '../ajax';

export default {
  get: (key) => Ajax('get', `config/${key}`),
  createOrUpdate: (key, data) => Ajax('post', `config/${key}`, data),
  getHomeProduct: () => Ajax('get', 'config/homeproduct'),
};
